export default "__VITE_PUBLIC_ASSET__a09dc777__"